import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';
import { ToastrModule } from 'ngx-toastr';
import { AddressTaxDialogue } from './address-tax-setup/address-tax-dialogue.component';
import { FormatLicenceLimitsPipe } from './formatLicenceLimits.pipe';
import { SubscriptionBanner } from './subscription-banner.component';
import { SubscriptionLicences } from './subscription-licences.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        NgSelectModule,
        ToastrModule,
        SharedUiModule,
        FormlyModule,
        RouterModule.forChild([])
    ],
    declarations: [
        SubscriptionLicences,
        FormatLicenceLimitsPipe,
        AddressTaxDialogue,
        SubscriptionBanner
    ],
    exports: [
        SubscriptionLicences,
        FormatLicenceLimitsPipe,
        AddressTaxDialogue,
        SubscriptionBanner
    ]
})
export class SubscriptionsModule {}
